import { jsx } from "react/jsx-runtime";
import { Box } from "@mui/material";
import { forwardRef } from "react";
import { spreadSx } from "../utils/spreadSx.js";
const Nowrap = forwardRef(({ children, lines = 1, sx, ...restProps }, ref) => /* @__PURE__ */ jsx(
  Box,
  {
    component: "span",
    className: "nowrap-body",
    sx: [
      styles.container,
      lines === 1 ? { whiteSpace: "nowrap" } : {},
      ...spreadSx(sx)
    ],
    ...restProps,
    ref,
    children: /* @__PURE__ */ jsx(
      Box,
      {
        component: "span",
        sx: [
          styles.innerContainer,
          lines > 1 ? {
            display: "-webkit-box",
            WebkitLineClamp: lines,
            WebkitBoxOrient: "vertical"
          } : {}
        ],
        children
      }
    )
  }
)), styles = {
  container: {
    display: "inline-flex",
    minWidth: 0,
    maxWidth: "100%"
  },
  innerContainer: {
    overflow: "hidden",
    minWidth: 10,
    textOverflow: "ellipsis"
  }
};
export {
  Nowrap
};
//# sourceMappingURL=Nowrap.js.map
